import _uniq from 'hs-lodash/uniq';
export const generatePropertiesDetailsBody = ({
  defaultProperties,
  associationCardProperties
}) => {
  const propertiesNames = _uniq([...defaultProperties, ...associationCardProperties.primaryProperties, ...associationCardProperties.secondaryProperties, 'hs_object_id']);
  return {
    inputs: propertiesNames.map(name => ({
      name
    })),
    archived: false
  };
};